import img1 from "../assets/gallery/NorthEast/northeast1.jpg";
import img2 from "../assets/gallery/NorthEast/northeast2.jpg";
import img3 from "../assets/gallery/NorthEast/northeast3.jpg";
import img4 from "../assets/gallery/NorthEast/northeast4.jpg";
import img5 from "../assets/gallery/NorthEast/northeast5.jpg";
import img6 from "../assets/gallery/NorthEast/northeast6.jpg";
import img7 from "../assets/gallery/NorthEast/northeast7.jpg";
import img8 from "../assets/gallery/NorthEast/northeast8.jpg";
import img9 from "../assets/gallery/NorthEast/northeast9.jpg";
import img10 from "../assets/gallery/NorthEast/northeast10.jpg";

const northEastGallery = [
  { img: img1, rowSpan: 2 }, // tall
  { img: img2 },
  { img: img3 },

  { img: img4, colSpan: 2 }, // wide
  { img: img5 },

  { img: img6 },
  { img: img7 }, // tall

  { img: img8 },
  { img: img9 },

  { img: img10 },
];

export default northEastGallery;
